import React, { useEffect, useState, createContext, useContext, useMemo } from "react"

var idCounter = 0;

interface IValue {
    json: string | null
    state: any
    setIsUncommited: (v: boolean) => void
}

interface IScope {
    [id: number]: IValue
}

const check = (s : IScope) =>{
    var res = false;
    for (var itemId in s) {
        var v = s[itemId];
        if (v.json == null || (JSON.stringify(v.state) != v.json)) {
            res = true;
            break;
        }
    }
    return res;
}

const CommitedStateContext = createContext<IScope>({});

export const useCommitedState = (state: any): [() => void, boolean] => {
    const scope = useContext(CommitedStateContext);

    const [id] = useState<number>(() => {
        return ++idCounter;
    });

    const [commitCounter, setCommitCounter] = useState(0);
    const [isUncommited, setIsUncommited] = useState(false);


    // Get current value
    const value = useMemo(() => {
        var v: IValue = scope[id];
        if (!v) {
            v = { state, json: null, setIsUncommited }
            scope[id] = v;
        }
        return v;
    }, [id, scope])

    // Remove state when component is unmounted
    useEffect(() => {
        return function () {
            delete scope[id];

            const res = check(scope);
            for (var itemId in scope) {
                var v = scope[itemId];
                v.setIsUncommited(res);
            }
        }
    }, [])

    // Update values
    value.state = state;
    value.json = useMemo(() => {
        return JSON.stringify(state);
    }, [commitCounter])
    value.setIsUncommited = (v) => {
        if(v != isUncommited) {
            setIsUncommited(v);
        }
    };

    // Increment counter to update json next time when state is updated
    const commit = () => {
        setCommitCounter(commitCounter + 1);
    }

    // Propagate isUncommited flag across the scope
    useEffect(() => {
        const res = check(scope);
        for (var itemId in scope) {
            var v = scope[itemId];
            v.setIsUncommited(res);
        }
    }, [value.state, value.json])

    return [commit, isUncommited];
}

export const CommitedStateScope: React.FC = (props) => {
    return <CommitedStateContext.Provider value={{}}>
        {props.children}
    </CommitedStateContext.Provider>
}